import Marquee from "react-fast-marquee";
import { LANDING } from "@/constants/testIds";

const QUOTES = [
  {
    text: "Chef Kristy supplied my Thanksgiving dinner this year and I immediately realized her rustic yet refined style of cooking makes her someone to watch. And to think she almost didn't become a chef.",
    author: "Simeon",
    location: "Thanksgiving 2025",
  },
  {
    text: "The catering for our anniversary dinner was flawless. Bahamian soul, refined execution, and warmth in every course.",
    author: "David & Priya",
    location: "Exuma",
  },
  {
    text: "Fresh conch, fire-grilled snapper, rum-poached pineapple. She cooks the islands with a whisper of Paris.",
    author: "Chef’s Table Guest",
    location: "Nassau",
  },
  {
    text: "Our charter guests still ask for her recipes. Book her before someone else does.",
    author: "Captain R.",
    location: "Bahamas Yachting",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid={LANDING.testimonialsSection}
      className="relative bg-[#4A5D4E] py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 mb-14 md:mb-16">
        <div className="reveal flex items-center gap-3 mb-6">
          <span className="h-px w-8 bg-[#F4F1EA]" />
          <span className="font-mono-editorial text-[11px] text-[#F4F1EA]/80">
            04 · KIND WORDS
          </span>
        </div>
        <h2 className="reveal font-display font-light text-[#F4F1EA] leading-[1.02] text-4xl md:text-5xl lg:text-6xl tracking-tight max-w-3xl">
          What her guests
          <br />
          <span className="italic">carry home.</span>
        </h2>
      </div>

      <Marquee
        gradient={false}
        speed={40}
        pauseOnHover
        className="text-[#F4F1EA]"
      >
        {QUOTES.map((q, i) => (
          <div
            key={i}
            className="flex items-center gap-16 md:gap-32 pr-16 md:pr-32"
          >
            <div className="max-w-[520px] md:max-w-[720px] shrink-0">
              <p className="font-display italic text-2xl md:text-4xl text-[#F4F1EA] leading-snug">
                “{q.text}”
              </p>
              <div className="mt-4 font-mono-editorial text-[10px] text-[#F4F1EA]/70">
                {q.author.toUpperCase()} · {q.location.toUpperCase()}
              </div>
            </div>
            <div className="font-display text-6xl md:text-8xl text-[#F4F1EA]/25 shrink-0">
              ✦
            </div>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
